import { apiRequest } from './index';

export const fetchCompanyRequest = ( id, success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest('/companies/' + id, {}, success, failure);
}

export const fetchCompaniesRequest = ( success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest('/companies', {}, success, failure);
}

export const createCompanyRequest = ( data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/companies',
        { 
            method: 'POST',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const editCompanyRequest = ( id, data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/companies/' + id,
        { 
            method: 'PUT',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

const buildCompanyOptions = company => ({
    value: company ? company._id : '',
    label: company ? company.companyName : '',
    data: company
});

export const companySelectOptionRequest = (success = (result = []) => {}, failure = (error) => {}) =>{
    fetch(process.env.REACT_APP_API_ENDPOINT + '/companies')
        .then(response => response.json())
        .then(data => {
            const selectOptions = [];
            data.forEach((item) => {
                const option = buildCompanyOptions(item);
                selectOptions.push(option);
            });
            success(selectOptions);
        })
        .catch(error =>{
            failure(error.status);
        });
}

export const deleteCompanyRequest = ( id, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/companies/' + id,
        { method: 'DELETE' },
        success,
        failure
    )
}
